import { render, staticRenderFns } from "./image_table.vue?vue&type=template&id=7d12acd6&scoped=true&"
import script from "./image_table.vue?vue&type=script&lang=js&"
export * from "./image_table.vue?vue&type=script&lang=js&"
import style0 from "./image_table.vue?vue&type=style&index=0&id=7d12acd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d12acd6",
  null
  
)

export default component.exports